import InAppMessage from "./in-app-message.js";
export default class HtmlMessage extends InAppMessage {
  constructor(i, o, d, e, r, t, s, v, n, u, a, c) {
    super(
      i,
      void 0,
      void 0,
      o,
      d,
      void 0,
      void 0,
      void 0,
      (e = e || InAppMessage.DismissType.MANUAL),
      r,
      void 0,
      void 0,
      void 0,
      void 0,
      void 0,
      void 0,
      void 0,
      void 0,
      t,
      s,
      void 0,
      void 0,
      void 0,
      v,
      void 0,
      void 0,
      void 0,
      n,
      u,
      c,
      void 0,
      void 0,
    ),
      (this.messageFields = a),
      (this.messageFields = a);
  }
  Po() {
    return !1;
  }
  $t(i) {
    if (this.po === InAppMessage.ho.Hr) {
      if (this.So) return !1;
      this.So = !0;
    }
    return this.ti.X(i), !0;
  }
  bt() {
    const i = super.bt(HtmlMessage.rs);
    return (i[InAppMessage.hs.Ho] = this.messageFields), i;
  }
  static Xr(i) {
    return new HtmlMessage(
      i[InAppMessage.hs.Vr],
      i[InAppMessage.hs.bs],
      i[InAppMessage.hs.Yr],
      i[InAppMessage.hs.sa],
      i[InAppMessage.hs.ta],
      i[InAppMessage.hs.fa],
      i[InAppMessage.hs.da],
      i[InAppMessage.hs.xa],
      i[InAppMessage.hs.wa],
      i[InAppMessage.hs.CSS],
      i[InAppMessage.hs.Ho],
      i[InAppMessage.hs.ya],
    );
  }
}
HtmlMessage.rs = InAppMessage.ho.Hr;
